import { t } from "i18next"
import React from "react"

type Props = {
    ids?: number[]
    label: string
}

export function NumberIdsDialog({ ids, label }: Props) {

    type NumberItemProps = {
        id: number
    }

    const NumberItem = ({ id }: NumberItemProps) => {
        return (
            <div key={id} style={{ display: "flex", flex: "1", gap: "4px", marginTop: "4px" }}>
                <div style={{ flex: "2" }} className="table-row-dashboard">
                    <p className="table-header-dashboard-row" style={{ fontWeight: "700" }}>{id}</p>
                </div>
            </div>
        )
    }


    return (
        <div style={{ display: "flex", flex: "1", flexDirection: "column", marginTop: "20px", width:"300px" }}>
            <p className="table-label-indicator" style={{ alignSelf: "center" }}>{label}</p>
            <div style={{ display: "flex", flex: "1", gap: "4px", marginTop: "20px" }}>
                <div style={{ flex: "2" }} className="table-header-dashboard">
                    <p className="table-header-dashboard-title">{t('id')}</p>
                </div>
            </div>
            {ids?.sort((p1, p2) => p1 === p2 ? 0 : p1 < p2 ? -1 : 1).map(h => <NumberItem id={h} />)}
        </div>
    )
}